import { SyntheticEvent } from 'react'

import { Button } from '../../../Button'
import { Checkbox } from '../../../Checkbox'
import * as S from '../../CheckPicker.styles'
import { CheckPickerItemType, CheckPickerOnSelect } from '../../CheckPicker.types'
import { OptionCheckbox } from '../OptionCheckbox'

interface MenuHeaderProps<OptionType extends string> {
  hideAllOption?: boolean
  customAllText?: string
  customAllValue?: string
  subtitle?: string
  hasSelection: boolean
  selectedOptions: CheckPickerItemType<OptionType>[]
  value?: OptionType[]
  onClean?: (event: SyntheticEvent) => void
  onSelect?: CheckPickerOnSelect<OptionType>
}

export const MenuHeader = <OptionType extends string>({
  hideAllOption,
  customAllText,
  customAllValue,
  subtitle,
  hasSelection,
  selectedOptions,
  value,
  onClean,
  onSelect,
}: MenuHeaderProps<OptionType>) => (
  <S.MenuWrapper $removeBottomBorder={hideAllOption}>
    <S.ContainerActions>
      {hideAllOption ? null : (
        <Checkbox.Regular
          id={`checkbox-all-${new Date().toString()}`}
          value={customAllValue ?? 'all'}
          title={customAllText ?? 'All'}
          checked={!hasSelection}
          onChange={onClean}
        />
      )}
      {subtitle ? <S.Subtitle>{subtitle}</S.Subtitle> : null}
      {onClean ? (
        <Button.Flat disabled={!hasSelection} onClick={onClean}>
          Clear
        </Button.Flat>
      ) : null}
    </S.ContainerActions>
    {selectedOptions.map(option => (
      <OptionCheckbox
        key={option.value}
        label={option.label}
        option={option}
        value={value}
        onSelect={onSelect}
      />
    ))}
  </S.MenuWrapper>
)
